module.exports = __webpack_public_path__ + "assets/8d24adabdb5a98040bbf1d9f8bf0480e.svg";